import { render } from "./HumorPage.vue?vue&type=template&id=799e28ba"
import script from "./HumorPage.vue?vue&type=script&lang=js"
export * from "./HumorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__